export default __webpack_public_path__ + "static/media/mconferences.bda09cbb.jpg";